"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClientWindowSize = exports.ClientWindowSizes = exports.WindowSizes = void 0;
var WindowSizes = {
  LG: 'LG',
  MD: 'MD',
  SM: 'SM',
  XS: 'XS'
};
exports.WindowSizes = WindowSizes;
var ClientWindowSizes = {
  LG: 1280,
  MD: 992,
  SM: 576,
  XS: 320
};
exports.ClientWindowSizes = ClientWindowSizes;

var getClientWindowSize = function getClientWindowSize(windowWidth) {
  return Object.keys(ClientWindowSizes).find(function (key) {
    var ruleSize = ClientWindowSizes[key];
    return windowWidth >= ruleSize;
  });
};

exports.getClientWindowSize = getClientWindowSize;